module.exports = __webpack_public_path__ + "static/img/KH@3x.fa8b1530.png";